import React from 'react'
import HeroBanner from '../components/Distributor/HeroBanner'
// import { Link } from 'react-router'
import WhyPartner from '../components/Distributor/WhyPartner'
import Application from '../components/Distributor/Application'
import CmsPageHero from '../components/CmsPageHero'

const Distributor = () => {
    return (
        <>
            <CmsPageHero slug="distributor"><HeroBanner /></CmsPageHero>
            <WhyPartner />
            <Application />
        </>
    )
}

export default Distributor
